import md5 from 'js-md5'
export default {   
    CalcuMD5(pwd) {        
        pwd = md5(pwd);
        return pwd;

    }
}